
<ng-container *ngIf='!skelton_loaders'>
    
    <div class="slots_card--img-wrap" appLazyLoadImage [appLazyLoadImage]="siteUrlPath+'/'+gameUrlPath+'/'+game.gameCode+'/'+game.gameCode+'.jpg'" [errorPlaceholder] = "siteUrlPath + '/' + mediaPath + '/common/placeholder.png'">
        <!-- <h3  class="featured__title" *ngIf="featuredTagGames">{{'gamingComp.gaming34' | translate}}</h3> -->
        <h3 class="featured__title" *ngIf="priorityTag">
            {{ ('gamingComp.' + priorityTag) | translate }}
          </h3>
        <!-- <img class="slots_card--img-wrap-card"  *ngIf="imageLoadedError" src="{{siteUrlPath}}/{{mediaPath}}/common/placeholder.png"  alt="{{game.name}}" (click)="gameLauncher('imageClick',game)" priority/> -->
        <img class="slots_card--img-wrap-card"  [ngStyle]="{ 'display': imageLoadedError ? 'none': '' }" (load)="imageLoaded()" (error)="handleImageError($event)"  alt="{{game.name}}" (click)="gameLauncher('imageClick',game)"/>
        <div class="slots_card--img-wrap-hover sweep-to-top" *ngIf="windowType === 'desktop'">
            <div class="middleAlignBlock">
                <div class="center-align-hover">
                    <div class="slots-play-btn">
                        <img class="slots_card--play" [ngClass]="!userLogin ? 'notloggedin' : ''" (click)="gameLauncher('real',game)" src="{{siteUrlPath}}/{{mediaPath}}/common/play_btn.png" alt="play game btn" />
                    </div>
                    <div class="slots-play-funbtn" *ngIf="game.hasDemo > 0 && !isDemoGamesExempted && !userLogin">
                        <a (click)="gameLauncher('demo',game)"
                        >{{'gamingComp.gaming23' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
        <app-live-casino-details [game]="game" [liveGameDetails]="liveGameDetails" *ngIf="game.gameType === 'live_casino' && liveGameDetails"></app-live-casino-details>
    </div>
    <div class="slots_card--footer">
        <div class="slots_card--pull-left" [ngClass]="{'loggedin' : isUserLoggedIn}">
            <h2 class="slots_card--title" title="{{game.name}}">{{game.name}}</h2>
            <h4 class="slots_card--desc" title="{{game.vendorDisplayName | uppercase}}">{{game.vendorDisplayName}}</h4>
        </div>
        <i class="icon slots_card--fav icon-heart" 
            *ngIf="isUserLoggedIn"
            [ngClass]="isFavourite ? 'slots_card--fav-selected' : ''" (click)="setFavouriteGames(game.gameCode)">
        </i>
    </div>
</ng-container>

<ng-container *ngIf='skelton_loaders'>
    <div class="slots_card--img-wrap"></div>
    <div class="slots_card--footer">
        <div class="slots_card--pull-left">
            <h2 class="slots_card--title animated-background"></h2>
            <h4 class="slots_card--desc animated-background"></h4>
        </div>
    </div>
</ng-container>